@if (isLoading()) {
  <app-dashboard-list-card-skeleton>
    <ul class="flex-1 flex flex-col gap-2">
      <li class="flex gap-3 items-center">
        <ui-skeleton class="block size-5 flex-none rounded-md" />
        <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
      </li>
    </ul>
  </app-dashboard-list-card-skeleton>
} @else {
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-58"
  >
    @if (error()) {
      <app-error-component
        class="block h-full"
        (clickRetry)="onClickReload()"
        [enableRetry]="true"
      />
    } @else {
      <div class="flex gap-2 items-center">
        <h4 class="font-semibold leading-6 flex-1">
          {{ 'cockpit.dashboard.supplierContractsCard.title' | transloco }}
          @if (totalCountCurrentYear() > 0) {
            <span> ({{ totalCountCurrentYear() }}) </span>
          }
        </h4>
        <ui-button
          mode="outlined"
          [iconOnly]="true"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
        >
          <ng-icon name="heroArrowRight" size="20" class="!block" />
        </ui-button>
      </div>
      <ul class="flex-1 flex flex-col gap-2">
        @for (supplierContract of supplierContracts(); track supplierContract.id) {
          <li
            class="flex gap-3 items-center p-2 text-sm leading-6"
            [ngClass]="[
              {
                ELECTRICITY:
                  'text-on-power-soft dark:text-on-power-soft-darkmode bg-power-soft dark:bg-power-soft-darkmode',
                GAS: 'text-on-gas-soft dark:text-on-gas-soft-darkmode bg-gas-soft dark:bg-gas-soft-darkmode',
              }[supplierContract.utilityType],
            ]"
          >
            @switch (supplierContract.utilityType) {
              @case ('ELECTRICITY') {
                <ng-icon name="heroBolt" size="20" class="!block" class="flex-none" />
              }
              @case ('GAS') {
                <ng-icon name="heroFire" size="20" class="!block" />
              }
            }
            <span class="flex-1 line-clamp-1">
              {{ supplierContract.supplierName }} {{ supplierContract.productName }}
            </span>
            @if (supplierContract.latestCheckResult?.alertCount; as count) {
              <ui-badge color="error" mode="filled" rounded="full" class="flex-none">{{
                count
              }}</ui-badge>
            }
          </li>
        } @empty {
          @if (hasContractsInOtherYears()) {
            <li
              class="block h-full w-full flex items-center justify-center text-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
            >
              {{
                'cockpit.dashboard.supplierContractsCard.emptyStateInYear'
                  | transloco: { year: yearInSupply() }
              }}
            </li>
          } @else {
            <li
              class="block h-full w-full flex items-center justify-center text-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
            >
              {{ 'cockpit.dashboard.supplierContractsCard.emptyState' | transloco }}
            </li>
          }
        }
      </ul>
      @if (totalCountCurrentYear() > limit()) {
        <ui-button
          mode="ghost"
          expand="full"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
          >+{{ totalCountCurrentYear() - limit() }}
          {{ 'cockpit.dashboard.supplierContractsCard.more' | transloco }}</ui-button
        >
      }
    }
  </div>
}
